import React from "react";
import SideMenu from "./SideMenu";

const UserLayout = ({ children }) => {
    const menuItems = [
        {
            name: "Profile",
            "url": "/me/profile",
            icon: "fas fa-user",
        },
        {
            name: "Update Profile",
            "url": "/me/update_profile",
            icon: "fas fa-user",
        },

        {
            name: "Update Password",
            "url": "/me/update_password",
            icon: "fas fa-lock",
        },
    ];

    return (
        <div className="user-layout">
            {/* Header */}
            <div className=" mb-5 py-1 text-center">
                <h2 className="fw-bold heading">User Settings 🧚🏻‍♀️</h2>
                <p className="text-muted">
                    Manage your profile, orders & preferences with ease.
                </p>
            </div>

            {/* Content */}
            <div className=" container">
                <div className="row justify-content-around">
                    {/* Sidebar */}
                    <div className="col-12 col-lg-3 mb-4">
                        <div className="card shadow-sm rounded-4 p-4  border-0 sticky-card" style={{
                            minHeight: "180px",
                            maxHeight: "180px",
                            position: "sticky",
                            top: "100px",
                        }}>

                            <SideMenu menuItems={menuItems} />
                        </div>
                    </div>

                    {/* Dashboard Content */}
                    <div className="col-12 col-lg-8">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserLayout;